import React from 'react';
import PropTypes from 'prop-types';
import AssignmentsRow from './AssignmentRow';

/**
 * @typedef {import('../../types/Assignments').Assignment} Assignment
 * @typedef {import('../../data/WizardData').default} WizardData
 */

/**
 * AssignmentTable component - displays assignments in a selectable HTML table.
 * @param {Object} props
 * @param {Assignment[]} props.assignmentsList - List of assignments to display.
 * @param {WizardData} props.wizardData - The wizard data instance.
 * @param {function} props.onToggle - Callback when a row selection is toggled.
 * @param {function} props.changeParentHandler - Callback to change the parent location in the URL.
 * @returns {JSX.Element}
 */
export function AssignmentTable({ assignmentsList, wizardData, onToggle, changeParentHandler }) {
  return (
    <div className="table">
      <table className="selections">
        <thead>
          <tr>
            <th />
            <th>Type</th>
            <th>Name</th>
            <th>Description</th>
            <th title={`Devices assigned to Sequence: ${wizardData.name} (Assigned / All devices)`}>
              Sequence Assigned
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {assignmentsList.map(assignment => (
            <AssignmentsRow
              key={assignment.id}
              assignment={assignment}
              isSelected={wizardData.isAssignmentSelected(assignment)}
              readOnly={wizardData.isAssignmentAlreadyAssigned(assignment)}
              onToggle={onToggle}
              changeParentHandler={changeParentHandler}
            />
          ))}
        </tbody>
        {assignmentsList.length === 0 && (
          <tfoot>
            <tr>
              <td colSpan="6">No assignments available here</td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}

AssignmentTable.propTypes = {
  assignmentsList: PropTypes.array.isRequired,
  wizardData: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
  changeParentHandler: PropTypes.func.isRequired,
};
